export const RELATED_PRODUCTS_WRAPPER_SELECTOR =
  '.cart-drawer__on-side-related-products-carousel-wrapper'

export const hasCartDrawerAsideProducts = node =>
  Boolean(node?.querySelector(RELATED_PRODUCTS_WRAPPER_SELECTOR))
